import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, WA_LINK } from "@/constants/site";

export default function FloatingContact() {
  return (
    <div
      data-testid="floating-contact-bar"
      className="fixed inset-x-4 bottom-4 z-40 flex justify-center gap-3 sm:inset-x-auto sm:right-6 sm:bottom-6"
    >
      <a
        data-testid="floating-call-button"
        href={PHONE_TEL}
        aria-label="Chiama RistrutturaCasa"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#C85A32] text-[#FAF8F5] shadow-[0_8px_30px_rgba(200,90,50,0.45)] transition-transform duration-300 hover:-translate-y-1"
      >
        <Phone size={22} />
      </a>
      <a
        data-testid="floating-whatsapp-button"
        href={WA_LINK}
        target="_blank"
        rel="noreferrer"
        aria-label="Scrivi a RistrutturaCasa su WhatsApp"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#161514] text-[#FAF8F5] shadow-[0_8px_30px_rgba(22,21,20,0.4)] transition-transform duration-300 hover:-translate-y-1"
      >
        <MessageCircle size={22} />
      </a>
    </div>
  );
}
